// ydUserId作为公参已经在sendLoginInfo函数中同步，私参数请不要再加了，否则会删除掉
function reportToRlog(eventName, parmas) {
  let isObject = Object.prototype.toString.call(parmas) === '[object Object]'
  if (isObject) {
    // 增加参数
    Object.keys(parmas).forEach(key => {
      _rlog.push(['_addPost', key, parmas[key]])
    })
  }
  _rlog.push(['_trackEvent', eventName])
  if (isObject) {
    // 删除参数
    Object.keys(parmas).forEach(key => {
      _rlog.push(['_removePost', key])
    })
  }
}

export default reportToRlog
